/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 * The tokens to replace in fixedPromptIntro with the word counts being edited (read-only).
 * @export
 * @interface ProductDescriptionSettingsDTOPromptPlaceholders
 */
export interface ProductDescriptionSettingsDTOPromptPlaceholders {
  /**
   * Stands for the minimum word count.
   * @type {string}
   * @memberof ProductDescriptionSettingsDTOPromptPlaceholders
   */
  minWords: string;
  /**
   * Stands for the maximum word count.
   * @type {string}
   * @memberof ProductDescriptionSettingsDTOPromptPlaceholders
   */
  maxWords: string;
}

/**
 * Check if a given object implements the ProductDescriptionSettingsDTOPromptPlaceholders interface.
 */
export function instanceOfProductDescriptionSettingsDTOPromptPlaceholders(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "minWords" in value;
  isInstance = isInstance && "maxWords" in value;

  return isInstance;
}

export function ProductDescriptionSettingsDTOPromptPlaceholdersFromJSON(
  json: any
): ProductDescriptionSettingsDTOPromptPlaceholders {
  return ProductDescriptionSettingsDTOPromptPlaceholdersFromJSONTyped(json, false);
}

export function ProductDescriptionSettingsDTOPromptPlaceholdersFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ProductDescriptionSettingsDTOPromptPlaceholders {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    minWords: json["minWords"],
    maxWords: json["maxWords"]
  };
}

export function ProductDescriptionSettingsDTOPromptPlaceholdersToJSON(
  value?: ProductDescriptionSettingsDTOPromptPlaceholders | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    minWords: value.minWords,
    maxWords: value.maxWords
  };
}
